import DOMPurify from "dompurify";

export const sanitizeHTML = ({ html }: { html: string }) => {
  const cleanHTML = DOMPurify.sanitize(html);
  return { __html: cleanHTML };
};
